<template>
  <v-sheet class="rounded-lg px-2 py-0">
    <v-container fluid class="pa-2"
      ><v-row align="center">
        <v-col md="3" cols="6" v-if="contributor">
          <v-row align="center">
            <v-col cols="auto" class="pr-0">
              <v-avatar size="45">
                <img
                  v-if="contributor.userProfile.image"
                  :src="contributor.userProfile.image"
                />
                <v-icon size="45" v-else>mdi-account-circle</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="auto">
              <div class="name-and-username">
                <v-row>
                  {{
                    $t("fullName", {
                      firstName: contributor.userProfile.firstName,
                      lastName: contributor.userProfile.lastName,
                    })
                  }}
                </v-row>
                <v-row>
                  <span class="username">
                    @{{ contributor.userProfile.username }}
                  </span>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="3" cols="6" v-else>
          <span class="website">{{ contribution.contributorWebsite }}</span>
        </v-col>
        <v-col
          v-if="showRole"
          cols="6"
          md="5"
          style="font-size: 1.2em"
          class="text-left"
          ><span class="role-span"
            >{{ $t("storyHub.publishing.wizard.role") }}:</span
          >
          {{ role }}</v-col
        >
        <v-spacer />
        <v-col v-if="editable" cols="auto">
          <DeleteContribution :id="contribution.id" /> </v-col></v-row
    ></v-container>
  </v-sheet>
</template>
<script>
import DeleteContribution from "./DeleteContribution";
export default {
  props: {
    contribution: Object,
    showRole: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
  },
  components: {
    DeleteContribution,
  },
  computed: {
    contributor() {
      return this.contribution.contributor;
    },
    role() {
      return this.contribution.role._id;
    },
  },
};
</script>
<style scoped>
.role-span {
  color: var(--v-secondaryAction-base);
}
.website {
  color: var(--v-secondaryAction-base);
}
.username {
  color: #b8b8b8;
}
.name-and-username {
  font-size: 0.9em;
}
</style>